import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import { TabsContent } from './TabsContent';
import { renderTableWithoutHeader } from '../../../helper/common';
import { usePrepareIrrigationEquationDetailsTableData } from '../../../helper/recommendationHooks';
import AddOrEditCustomKcValue from './AddOrEditCustomKcValue';
import { IrrigationRecommendationTuning } from './IrrigationRecommendationTuning';

const modalTitle = 'Add Or Edit Custom Kc Value';

export function IrrigationEquationDetails({
  recommendation, units, ranchId,
  customKcValue
}){
  const [activeTabKey, setActiveTabKey] = useState('1');
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();
  const { block } = recommendation || {};
  const tuningContent = block ? <IrrigationRecommendationTuning blockId={Number(block)} /> : null;

  function onClick() {
    setShowModal(!showModal);
  }

  const {
    availableWater,
    recommendedRuntimeDetails,
    totalHoursToReachTarget,
    additionalHoursToReachTarget,
    predictedDeficit,
    irrigationSystem,
    summary
  } = usePrepareIrrigationEquationDetailsTableData(recommendation,
    units, ranchId, customKcValue, setActiveTabKey, onClick, t);

  const items = [
    {
      key: '1',
      label: t('Summary'),
      children: renderTableWithoutHeader(summary, true)
    },
    {
      key: '2',
      label: t('Available Water'),
      children: renderTableWithoutHeader(availableWater)
    },
    {
      key: '3',
      label: t('ETc'),
      children: renderTableWithoutHeader(predictedDeficit)
    },
    {
      key: '4',
      label: t('Irrigation System'),
      children: renderTableWithoutHeader(irrigationSystem)
    },
    {
      key: '5',
      label: t('Runtime Details'),
      children: (
        <>
          {renderTableWithoutHeader(recommendedRuntimeDetails)}
          <span className="bold-text">{t('Total hours to reach targets')}</span>
          {renderTableWithoutHeader(totalHoursToReachTarget)}
          <span className="bold-text">{t('Additional hours to reach targets')}</span>
          {renderTableWithoutHeader(additionalHoursToReachTarget)}
        </>)
    },
    {
      key: '6',
      label: t('Tuning'),
      children: tuningContent,
    },
  ];

  const onTabsChange = (key) => {
    setActiveTabKey(key);
  };

  function renderAddOREditCustomKcModal() {
    return (
      <Modal
        visible={showModal}
        centered
        closable
        onCancel={() => {
          setShowModal(false);
        }}
        footer={null}
        title={t(modalTitle)}
      >
        <AddOrEditCustomKcValue
          // eslint-disable-next-line react/jsx-no-bind
          onClick={onClick}
          customKcValue={customKcValue}
          blockId={block}
        />
      </Modal>
    );
  }

  return (
    <>
      <TabsContent activeKey={activeTabKey} renderContent={items} onChange={onTabsChange} />
      {renderAddOREditCustomKcModal()}
    </>
  );
}

IrrigationEquationDetails.propTypes = {
  renderContent: PropTypes.shape({}),
  recommendation: PropTypes.shape({}),
  units: PropTypes.shape(),
  ranchId: PropTypes.number.isRequired,
  customKcValue: PropTypes.string
};

IrrigationEquationDetails.defaultProps = {
  renderContent: {},
  recommendation: {},
  units: {
    deficit: 'millimeters',
    etcForecast: 'millimeters',
    totalWater: 'millimeters',
  },
  customKcValue: null,
};
